// extracted by mini-css-extract-plugin
export default {"p":"Joker_p__PF-Ls","h3":"Joker_h3__+pfTA"};